module.exports = __webpack_public_path__ + "static/img/advert_2_2.c6b368e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SharePrinting/advert_2_2.png
// module id = RjHA
// module chunks = 10